/* eslint-disable */

import Axios from 'axios'
import {merge} from 'lodash'
import store from '../store/index'
import {FormTemplateFactory} from '@parantion/components'

/*******************************************************************************
 Common functions used bij multiple api calls
 ******************************************************************************/
function deleteToken () {
  store.commit('parantion/user/SET_AUTH', false)
  delete Axios.defaults.headers.common['X-CSRFToken']
}

function setToken (token) {
  Axios.defaults.headers.common['X-CSRFToken'] = token
}

function checkToken () {
  // if (Axios.defaults.headers.common['X-CSRFToken'] || Axios.defaults.headers.common['X-CSRFToken'] === '') {
  //   setToken(store.state.parantion.user.token)
  // }
  if (store.state.parantion.user.token) {
    setToken(store.state.parantion.user.token)
  }
  Axios.defaults.headers.common['X-Database'] = store.state.parantion.user.database
}

function registerError (error, message?) {
  //deleteToken()
  // const message = errorData.status + ' - ' + errorData.statusText + '-' + errorData.data.message
  store.dispatch('parantion/error/registerError', {
    message: message,
    errorTrace: error.response
  })
}

function getBaseUrl () {
  return store.state.parantion.baseUrl + '/'
}

export default {
  /*******************************************************************************
   Service for Api related functions
   ******************************************************************************/
  defaultService: {
    async deleteToken () {
      await deleteToken()
    },
    setToken (token) {
      setToken(token)
    },
    async logout () {
      let response = await Axios.delete(getBaseUrl() + 'v51/account/access', {}).catch(error => {
        return ''
      })
      await deleteToken()
      return response
    },
    async testError (code) {
      let response = await Axios.get('v51/library/test/error/' + code)
      return response
    }
  },

  /*******************************************************************************
   * API service for all survey container related calls
   ******************************************************************************/
  surveyService: {
    /* ****************** multiple ****************************/
    async getSurveys (limit) {
      checkToken()
      // let response = await Axios.get(getBaseUrl() + 'v2/forms', {
      //   params: {
      //     // sort: ['frm_date_created'],
      //     field_name: ['frm_date_created', 'frm_nonamed_users_granted', 'frm_nonamed_users_used', 'frm_date_start', 'frm_date_end', 'frm_invite_sub', 'frm_invite_mes', 'frm_remind_sub', 'frm_remind_mes']
      //   }
      let response: any = await Axios.get('/v51/form', {
        params: {
          // sort: ['frm_date_created'],
          field: ['frm_date_created', 'frm_nonamed_users_granted', 'frm_nonamed_users_used', 'frm_date_start', 'frm_date_end', 'frm_invite_sub', 'frm_invite_mes', 'frm_remind_sub', 'frm_remind_mes']
        }
      }).catch(error => {
        if (error.response.status === 403 || error.response.status === 401) {
          deleteToken()
          return ''
        }
      })
      let surveys = response.data.form.reverse()
      for (let survey of surveys) {

        // TODO FIXME so we dont need V2 to v5 API Data conversion
        survey.fid = survey.fh
        survey.fields = survey.field
        survey.template = survey.tn
        survey.uid = survey.uh
        delete survey.field
        delete survey.tn
        delete survey.uh

        survey.surveyLoading = false
      }
      return surveys
    },

    async updateFields (surveyHash: string, fieldsObject: {[x: string]: any}, templateName: string) {
      const labelUpdate = 'frm_label' in fieldsObject
      checkToken()
      return Axios.put(getBaseUrl() + 'v51/form/' + surveyHash + '/field', {field: fieldsObject}).then(async (res) => {
        if (labelUpdate) {
          await Axios.put(getBaseUrl() + 'v51/template/' + templateName, {
            label: fieldsObject.frm_label
          })
        }
        return res
      })
    },

    /* ****************** Single *****************************/
    async getSurvey (containerHash) {
      checkToken() // Check if token is still in header
      const response: any = await Axios.get(getBaseUrl() + 'v51/form/' + containerHash, {
        params: {
          // sort: ['frm_date_created'],
          field: ['frm_date_created', 'frm_nonamed_users_granted', 'frm_nonamed_users_used', 'frm_date_start', 'frm_date_end', 'frm_invite_sub', 'frm_invite_mes', 'frm_remind_sub', 'frm_remind_mes']
        }
      }).catch(error => {
        if (error.response.status === 403 || error.response.status === 401) {
          deleteToken()
          return ''
        }
        /// registerError(error.response.data.message)
        return ''
      })

      response.data.form.forEach(form => {
        // TODO FIXME so we dont need V2 to v5 API Data conversion
        form.fid = form.fh
        form.fields = form.field
        form.template = form.tn
        form.uid = form.uh
        delete form.fh
        delete form.field
        delete form.tn
        delete form.uh
      })

      return response.data.form[0]
    },

    async postSurvey (survey) {
      checkToken()
      const copyTemplate = survey.content || JSON.stringify(FormTemplateFactory(''))
      const template = await Axios.post(getBaseUrl() + 'v51/template', {
        type: 'form_json',
        module: 'survey',
        status: 'active',
        label: survey.frm_label,
        description: survey.frm_label,
        contenttype: 'JSON',
        content: copyTemplate
      })
      // let fields = {frm_date_start: new Date().toISOString()}
      // TODO CHECK API. IS SHOULD ACCEPT ISO DATE BUT IT DOESNT
      let newDate = new Date()
      let fields: any = {frm_date_start: newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getUTCDate()}
      if (survey.respondents && survey.respondents > 0) fields.frm_nonamed_users_granted = survey.respondents

      let form = await Axios.post(getBaseUrl() + 'v51/form', {
        frm_label: survey.frm_label,
        type: 'survey',
        tn: template.data.tn,
        field: fields
      })
      let formConverted: any  = await Axios.get(getBaseUrl() + 'v51/form/' + form.data.form[0])
      // TODO FIXME so we dont need V2 to v5 API Data conversion
      formConverted = formConverted.data.form[0]
      formConverted.template = formConverted.tn
      formConverted.fid = formConverted.fh
      formConverted.fields = formConverted.field
      delete formConverted.field
      return formConverted
    },

    async getFields (variablesNamesArray) {
      const varArrays = []
      const VAR_AMOUNT_THRESHOLD = 40

      while (variablesNamesArray.length > VAR_AMOUNT_THRESHOLD) {
        varArrays.push(variablesNamesArray.splice(0, VAR_AMOUNT_THRESHOLD))
      }
      varArrays.push(variablesNamesArray) // Add the remaining amount

      const promises = varArrays.map(vars => this.getFieldsCall(vars))

      const result = await Promise.all(promises)

      return [].concat(...result)
    },

    async getFieldsCall (variablesNamesArray) {
      checkToken()
      let params = {
        name: variablesNamesArray
      }
      let response = await Axios.get('v51/var', {params: params})
        .catch(error => {
          if (error.response.status === 403) {
            //registerError(error.response.data.message)
            return ''
          }
          return error
        })

      return response.data.var
    },

    async getVarOptionGroups (optionGroupHashes) {
      checkToken()
      let data = []
      let i = 0
      let chunk = 10 //Create chunks of 10 hashes so the url won't be too long
      for (let j = optionGroupHashes.length; i < j; i += chunk) {
        let params = {
          vogh: optionGroupHashes.slice(i, i + chunk).join(';')
        }
        let response = await Axios.get('v51/varoption/option/group', {params: params})
          .catch(error => {
            if (error.response.status === 403) {
              //registerError(error.response.data.message)
              return ''
            }
            return error
          })
        data = [...data, ...response.data.varoptiongroup]
      }

      return data
    },

    async getTemplate (tid) {
      checkToken()
      let response = await Axios.get(getBaseUrl() + 'v51/template/' + tid + '?content_flag=1', {})
        .catch(error => {
          return error
        })

      let template = {}
      return response.data
    },

    async getDataV5 (surveyHash, variablesNamesArray, userHashes) {
      const varArrays = []
      const VAR_AMOUNT_THRESHOLD = 40

      while (variablesNamesArray.length > VAR_AMOUNT_THRESHOLD) {
        varArrays.push(variablesNamesArray.splice(0, VAR_AMOUNT_THRESHOLD))
      }
      varArrays.push(variablesNamesArray) // Add the remaining amount

      const promisses = varArrays.map(vars => this.getDataV5Call(surveyHash, vars, userHashes))

      // Put all the different rows in the same array again )we deal with duplicates later.
      const promiseResult = [].concat(...(await Promise.all(promisses)))

      // Merge the rows back together
      const result = promiseResult.reduce((results, value) => {
        const existingRow = results.find(result => {
          return result.form === value.form && result.template === value.template && result.fromsubject === value.fromsubject && result.tosubject === value.tosubject
        })

        if (existingRow) {
          merge(existingRow, value)
        }// Merge it with the same row with different vars
        else {
          results.push(value)
        } // Has no duplicate yet, just add it to the array

        return results
      }, [])

      // If the varnames are missing in a row, they are not set yet. So we need to set them again.
      result.forEach(result => {

        variablesNamesArray.forEach(varName => {
          if (result.row[varName] === undefined) result.row[varName] = ''
        })

      })

      return result

    },

    async getDataV5Call (surveyHash, variablesNamesArray, userHashes) {
      checkToken()

      await store.dispatch('parantion/template/setTemplateId', (store.state.parantion.template.template.tn || store.state.parantion.template.templateId)).then(() => {
        variablesNamesArray = [...variablesNamesArray, ...store.state.parantion.template.content.backgroundElements.map(o => {
          if (o.type === 'matrix'){
            return o.elements.map(e => e.name)
          } else {
            return o.name
          }
        }).flat()]
      })

      let params = {
        vars: variablesNamesArray,
        forms: surveyHash,
        // uh: userHashes
      }
      let response = await Axios.get('v51/data/bulk', {params: params})
        .catch(error => {
          if (error.response.status === 403) {
            //registerError(error)
            return ''
          }
          return error
        })
      return response.data.list
    },

    async setFormTemplateContent (templateHash, content) {
      console.log('setFormTemplateContent', templateHash)
      checkToken()
      try {
        const response = await Axios.put(getBaseUrl() + 'v51/template/' + templateHash + '/content', {
          content: content,
          contenttype: 'json'
        })
        return response
      } catch (error) {
        throw error.response.data.message[0]
      }
    },

    async getFormTemplateContent (templateHash) {
      checkToken()
      if (templateHash) {
        return Axios.get(getBaseUrl() + 'v51/template/' + templateHash + '/content')
          .catch(error => {
            if (error.response.status === 403) {
              //registerError(error.response.data.message)
              return ''
            }
            return error.response.data.message[0]
          })
      }
      return {content: {}}
    },

    async postReportTemplate ({parent, content, label}) {
      checkToken()
      try {
        return await Axios.post(getBaseUrl() + 'v51/template', {
          type: 'report_json',
          module: 'survey',
          status: 'active',
          label: label,
          description: label,
          contenttype: 'JSON',
          parent: parent,
          content: content
        })
      } catch (error) {
        console.log('%cERROR: ', 'color: red', error)
        throw error.response.data.message[0]
      }
    },

    // async getFormUserFields ({uid, fid}) {
    //   let response = await Axios.get( 'v2/forms/' + fid + '/users/' + uid)
    //   return response
    // },
    /**
     * @param uid
     * @param fid
     * @param email
     * @param noReminder bool
     * @returns {Promise.<void>}
     */
    async putFormUserFields ({uid, fid, email, noReminder}) {
      // GET /backend/api/v2/forms/{fid}/users/{uid}
      // PUT /backend/api/v2/forms/{fid}/users/{uid}
      checkToken() // Check if token is still in
      // let response = await Axios.put(getBaseUrl() + 'v2/forms/' + fid + '/users/' + uid, {

      let fields = {
        email: email
      }

      let response = await Axios.put(getBaseUrl() + 'v51/user/' + uid + '/field', {
        field: fields
      })
      return response
    },

    async putUserNoReminder ({uid, fid, noReminder}) {

      checkToken() // Check if token is still in
      // let response = await Axios.put(getBaseUrl() + 'v2/forms/' + fid + '/users/' + uid, {

      let vars = {
        sur_no_reminder: noReminder
      }

      return await Axios.put(getBaseUrl() + 'v51/data', {
        fid: fid,
        uid: uid,
        vars: vars
      })
    },

    async getTemplateDetails (templateHash, namesArray) {
      checkToken()
      return await Axios.get(getBaseUrl() + 'v51/template/' + templateHash + '/detail', {
        params: {
          detail: namesArray
        }
      })
    },

    async setTemplateDetails (templateHash, detailName, detailValue) {
      checkToken()
      let details = `detail[${detailName}]: ${JSON.stringify(detailValue)}`
      return Axios.put(getBaseUrl() + 'v51/template/' + templateHash + '/detail', details).catch(error => {
        //registerError(error.response.data.message)
        return error.response.data.message[0]
      })
    },

    async getTemplateReportContent (reportHash) {
      try {
        return await Axios.get(getBaseUrl() + 'v51/template/' + reportHash + '/content')
      } catch (error) {
        console.log('%cERROR: ', 'color: red', error)
        throw error.response.data.message[0]
      }
    },

    async deleteSurvey (formHash) {
      checkToken()
      return (await Axios.delete(getBaseUrl() + `v51/form/${formHash}`)).status
    },

    async getFormUsersPassword (fh, params) {
      let response = (await Axios.get(`v51/user?fh=${fh}&field=password`, {params: params}))?.data?.user
      return response
    }
  },

  /*******************************************************************************
   API service for all respondents related calls
   ******************************************************************************/
  distributionService: {
    async getRespondents (containerHash, objSearch, offset, limit) {
      checkToken() // Check if token is still in header
      console.log('%cERROR: ', 'color: red', 'getRespondents Deprecated')
    },

    async setRespondents (formHash, emailAddresses) {
      checkToken()
      const response = await Axios.post(`v51/form/${formHash}/user`, {
        'email': emailAddresses
      })
      //if (response.status === 403) registerError(error.response.data.message)
      return response.data
    },

    async generateRespondents ({formHash, prefix, count, makeCsvFile}) {
      checkToken()

      let params: any  = {
        'count': count,
        'file_flag' : makeCsvFile || 0
      }
      if(prefix) {
        params.prefix = prefix
      }
      const response = await Axios.post(`v51/form/${formHash}/user/logincode`, params)
      //if (response.status === 403) registerError(error.response.data.message)
      return response.data
    },

    async deleteRespondents (containerHash, users) {
      checkToken()
      let listOfHashes = []

      for (let user of users) {
        listOfHashes.push(user.uid)
      }

      // /backend/api/v2/forms/{fh}/users
      let response: any  = await Axios.delete(getBaseUrl() + 'v51/form/' + containerHash + '/user', {
        params: {
          uh: listOfHashes,
          data_present: '1'
        }
      }).catch(error => {
        return {error: error}
      })
      if (response.error) {
        return response
      }
      return response.data
    },

    async sendInvite ({fid, userHashArray, linkLogin, sender_email, reply_to_email, mail }) {
      checkToken()
      let params: any  = {
        uh: []
      }

      if (userHashArray && userHashArray.length >= 1) {
        params.uh = userHashArray
      }
      if (linkLogin) {
        //strReceiverEmail
        for (const user of userHashArray) {
          let response: any  = await Axios.post('/v51/ticket', {
            uh: user.hash,
            fh: fid,
            type: 'form_access',
            detail: {
              strReceiverEmail: user.email,
              blnProtectByAccesscode: 1,
              blnRequestAccesscode: 1,
              intRetryMax: 5,
              intRetryCount: 0,
              strAccesscode: ''
            }
          }).catch(error => {
            console.warn('error', error)
          })

          const ticketHash = response.data.tih

          await Axios.post(getBaseUrl() + 'v51/ticket/' + ticketHash + '/invite', {
            subject: mail.subject,
            body: mail.text
          }).catch(error => {
            if (error.response.status === 403) {
              registerError(error.response.data.message)
              return ''
            }
            store.dispatch('error/registerError', error.response.data.message, '')
            return error
          })
        }
      } else {

        if(sender_email) {
          params.sender_email = sender_email
        }
        if(reply_to_email) {
          params.reply_to_email = reply_to_email
        }

        let response = await Axios.post(getBaseUrl() + 'v51/form/' + fid + '/invite', params).catch(error => {
          if (error.response.status === 403) {
            //registerError(error.response.data.message)
            return ''
          }

          return error
        })
        return response.data
      }
    },


    async sendReminder ({fid, userHashArray, linkLogin, sender_email, reply_to_email}) {
      checkToken()

      let params: any  = {
        uh: {}
      }

      if(sender_email) {
        params.sender_email = sender_email
      }
      if(reply_to_email) {
        params.reply_to_email = reply_to_email
      }
      if (userHashArray && userHashArray.length >= 1) {
        params.uh = userHashArray
      }
      let response = await Axios.post(getBaseUrl() + 'v51/form/' + fid + '/remind', params).catch(error => {
        if (error.response.status === 403) {
          //registerError(error.response.data.message)
          return ''
        }
        return error
      })
      return response.data
    }
  },

  /*******************************************************************************
   API service for all User/profile related calls
   ******************************************************************************/
  userService: {
    async getFormUsers (fh, params) {
      checkToken()
      let response = (await Axios.get(getBaseUrl() + 'v51/form/' + fh + '/user',
          {params: params})).data.user
      let returnData = []

      // TODO FIXME so we dont need V2 to v5 API Data conversion
      response.forEach(user => {
        let newUser = {
          uid: user.uh,
          username: user.name,
          email: user.email,
          firstname: user.firstName,
          middlename: user.middlename,
          lastname: user.lastname,
          reminderno: user.sur_no_reminder,
          progress: user.frm_progress
        }
        returnData.push(newUser)
      })

      return returnData
    },

    async getUserCount (fh) {
      return Axios.get(getBaseUrl() + 'v51/form/count/user',
          {params: {fh: fh}}).then((res) => {
            return res.data.user[0] || []
          })
    },

    async getUserByEmail (params) {
      console.log(params)
      return Axios.get(getBaseUrl() + 'v51/user', {params: params}).then(res => {
          console.log(res)
            return res.data.user
      })
    },

    async getUserFields (userHash) {

      checkToken() // Check if token is still in header
      const field = ['email', 'firstname', 'lastname', 'middlename']
      return (await Axios.get(getBaseUrl() + 'v51/user/' + userHash + '/field', {params: {field: field}})).data
      // return (await Axios.get(getBaseUrl() + 'v2/users/' + userHash + '/fields')).data
    },

    // async updateUserFields (userHash, fields) {
    //   checkToken() // Check if token is still in
    //   let response = await Axios.put( 'v51/user/' + userHash + '/field', {params: {field: fields}})
    //   return response.data
    // },

    async getUserTask (userHash, formHash) {
      checkToken() // Check if token is still in header
      let response = await Axios.get(getBaseUrl() + 'v51/task', {params: {uh: [userHash], fh: formHash}})
      return response.data.tasks
    },

    async getUpsellableUserFields (userHash) {
      checkToken()
      const fields = ['forms_used', 'forms_granted', 'nonamed_users_used', 'nonamed_users_granted', 'account_valid']
      return (await Axios.get(getBaseUrl() + 'v51/user/' + userHash + '/field', {params: {field: fields}})).data.field
    }
  },
  /*******************************************************************************
   API service for all Survey Store related calls
   ******************************************************************************/
  surveyStoreService: {

    async sendPayment ({currency, description, price, method, templateNames, token, database}) {
      const headers = {
        'X-CSRFToken': token,
        'X-Database': database
      }
      const data = {currency: currency, description: description, price: price, method: method, templateNames: templateNames}
      return await Axios.post('https://surveystore.parantion.nl/payment', data, {headers: headers})
    },

    async listPaymentMethods ({token, database}) {
      const headers = {
        'X-CSRFToken': token,
        'X-Database': database
      }
      return await Axios.get('https://surveystore.parantion.nl/paymentmethods', {headers: headers})
    },

    async getPaymentInfo ({token, database, paymentId}) {
      const headers = {
        'X-CSRFToken': token,
        'X-Database': database
      }
      const data = {paymentId: paymentId}
      return await Axios.post('https://surveystore.parantion.nl/paymentinfo', data, {headers: headers})
    },

    async updatePaymentInfo ({token, database, paymentId, processed}) {
      const headers = {
        'X-CSRFToken': token,
        'X-Database': database
      }
      const data = {paymentId: paymentId, processed: processed}
      return await Axios.post('https://surveystore.parantion.nl/paymentupdate', data, {headers: headers})
    },

    async calculateCronbachScore ({token, database, itemscores}) {
      const headers = {
        'X-CSRFToken': token,
        'X-Database': database
      }
      const data = {itemscores: itemscores}
      return await Axios.post('https://surveystore.parantion.nl/cronbachalpha', data, {headers: headers})
    }
  }
}
